<style lang="less">
</style>
<template>
    <span>
        <Drawer title="考试条件" :closable="false" placement="right" v-model="examination" width="60%">
            <Row class="operation">
                <Button @click="add" type="primary" icon="md-add">新增条件</Button>
                <circleLoading v-if="operationLoading"/>
            </Row>
            <Row style="padding-top: 5px">
                <Table :loading="loading" border :columns="columns" :data="data" ref="userTable"></Table>
            </Row>
            <Row type="flex" justify="end" class="page">
                <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
            </Row>
        </Drawer>
        <item-drawer ref="itemDrawer"></item-drawer>
    </span>
</template>

<script>
    import {selectApplyList,delItem,resetApplyItem } from "@/api/bus";
    import itemDrawer from "./item-drawer";
    export default {
        name: "applyItem-manage",
        components: {
            itemDrawer
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                examination: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "sortOrder", // 默认排序字段
                    order: "asc", // 默认排序方式
                    examinationId: "",
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "index",
                        width: 50,
                        align: "center"
                    },
                    {
                        title: "申请条件",
                        align: "center",
                        key: "itemName"
                    },
                    {
                        title: "排序",
                        align: "center",
                        key: "sortOrder"
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.del(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            showDrawer(params){
                this.examination = true;
                if (params.id) {
                    this.searchForm.examinationId = params.id;
                    this.getDataList();
                }
            },
            getDataList() {
                this.loading = true;
                selectApplyList(this.searchForm).then(res => {
                    this.loading = false;
                    this.data = res.data.rows;
                    this.total = res.data.total;
                });
            },
            resetApplyItem(){
                resetApplyItem(this.searchForm.examinationId).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.$parent.getDataList();
                    }
                });
            },
            //设置发布状态
            setSessionsStatus(row,v){
                let params={
                    id:row.id,
                    status:v
                };
                setSessionsStatus(params).then(res => {
                    if (res.status === true) {
                        this.$Message.success(res.info);
                    }
                });
            },
            del(v) {
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除该条件吗?",
                    onOk: () => {
                        delItem(v.id).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.resetApplyItem();
                                this.getDataList();
                                this.$parent.getDataList();
                            }
                        });
                    }
                });
            },
            add() {
                let query = {examinationId: this.searchForm.examinationId};
                this.$refs.itemDrawer.showDrawer(query);
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
        },
        mounted() {
        }
    }
</script>
